<template>
  <section class="signin-screen">
    <el-col :md="12" :lg="10" :sm="24" :xs="24" :xl="10" class="login-screens-right">
      <section class="signin-form">
       <AuthNutronMobileLogo />
        <h3 class="form-title">Verify Account</h3>
        <el-form :model="verify_account" class="login-forms">
          <!-- keyup.enter.native="onSubmit" -->
          <el-row :gutter="30">
            <el-col :md="24">
              <el-form-item class="mb-0">
                <el-input v-model="verify_account.otp" placeholder="Verification Code" show-password autofocus></el-input>
                <span class="error" v-if="getErrors && getErrors['otp']">{{ this.getErrors['otp'].replace('otp', 'Verification code') }}</span>
              </el-form-item>
            </el-col>
            <el-col :md="24">
              <el-form-item class="flex-justify">
                <el-button
                  type="primary"
                  :loading="loading"
                  @click="onSubmit"
                  class="btn submit-btn"
                >Verify Account</el-button>

                <el-button
                  type="primary"
                  :loading="verifyLoading"
                  class="btn submit-btn"
                  @click="sendOtp"
                >Resend Code</el-button>
              </el-form-item>
            </el-col>
          </el-row>
          <span class="error" v-if="getErrors && getErrors['error']">{{ this.getErrors['error'] }}</span>
        </el-form>
        <div class="mobile-copyright hidden-md-and-up">
          <el-row>
            <el-col :xl="24">
              <p>
                Copyright © 2019
              </p>
            </el-col>
            <el-col :xl="24">
              <p>
                Powered by
                <a href="https://orotron.com/" target="_blank">OROTRON</a>
              </p>
            </el-col>
          </el-row>
        </div>
      </section>
    </el-col>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import AuthenticationLayout from "../../layouts/AuthenticationLayout.vue";
import AuthNutronMobileLogo from "./AuthNutronMobileLogo";

export default {
  name: "signin",
  components: {AuthNutronMobileLogo},
  data() {
    return {
      loading: false,
      verifyLoading: false,
      verify_account: {
        otp: "",
        username: ""
      }
    };
  },
  created() {
    this.$emit("update:layout", AuthenticationLayout);
    if(this.getMessage) {
      this.$message.success(this.getMessage)
    }
  },
  computed: {
    ...mapGetters("errors", ["getErrors", "getMessage"]),
    ...mapGetters("auth", ["getValidationErrors"]),
    username() {
      return this.$route.query.email;
    }
  },
  methods: {
    async onSubmit() {
      this.loading = true;
      this.verify_account.username = this.username;
      await this.$store.dispatch("auth/verifyAccount", this.verify_account);
      this.loading = false;
      if (this.getMessage) {
        this.$message.success('Your account is successfully verified. You can now login');
        await this.$store.dispatch("errors/clear");
        await this.$router.push("/signin");
      }
    },
    async sendOtp() {
      this.verifyLoading = true;
      let params = {
        username: this.$route.query.email
      };
      await this.$store.dispatch("auth/resendOTP", params);
      this.verifyLoading = false;
      if (this.getResendOtpStatus && this.getResendOtpStatus.success) {
        this.$message.success('A mail has been sent to your registered e-mail address with Verification code. Please check');
        await this.$store.dispatch("errors/clear");
      }
    }
  }
};
</script>

<style scoped lang="scss">
#verify-account-page {
  .flex-justify {
    .el-form-item__content {
      display: flex;
      justify-content: space-between;
    }
  }
  .error {
    line-height: 1.4;
    padding: 0;
    color: #11233f;
    font-weight: 500;
    font-family: "Work Sans", sans-serif;
    text-align: left;
    margin: 8px 0px 0px 0px;
  }
  .labelColor {
    color: 11233f;
    line-height: 2em;
  }
  .signin-other {
    margin-top: 30px;
    .signib-other-title {
      color: #fff;
      text-align: center;
      position: relative;
      overflow: hidden;
      text-transform: uppercase;
      font-size: 16px;
      &::after {
        content: "";
        position: absolute;
        width: 45%;
        top: 40%;
        transform: translateY(-50%);
        height: 1px;
        background: #fff;
        left: 0;
      }
      &::before {
        content: "";
        position: absolute;
        width: 45%;
        right: 0;
        top: 40%;
        transform: translateY(-50%);
        height: 1px;
        background: #fff;
      }
    }
    ul {
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 10px;
      li:not(:last-child) {
        margin-right: 15px;
      }
      li {
        img {
          width: 15px;
        }
        p {
          color: #fff;
          font-size: 13px;
          padding-bottom: 2px;
        }
      }
    }
  }
}
</style>
